{
  "name": "bmx-front-end",
  "version": "0.0.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "prebuild": "npm --no-git-tag-version version patch",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "debug": "ng serve",
    "availability:record": "ts-node -P tools/availability-regression/tsconfig.json tools/availability-regression/runner.ts record",
    "availability:test": "ts-node -P tools/availability-regression/tsconfig.json tools/availability-regression/runner.ts test",
    "availability:clean": "ts-node -P tools/availability-regression/tsconfig.json tools/availability-regression/runner.ts clean"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/localize": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@auth0/auth0-angular": "^2.0.2",
    "@azure/msal-browser": "^2.32.1",
    "@fullcalendar/angular": "^6.1.22",
    "@fullcalendar/core": "^6.1.22",
    "@fullcalendar/daygrid": "^6.1.22",
    "@fullcalendar/list": "^6.1.22",
    "@fullcalendar/timegrid": "^6.1.22",
    "@microsoft/signalr": "^7.0.5",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@primeuix/themes": "^3.1.0",
    "bootstrap": "^5.3.2",
    "chart.js": "^4.2.1",
    "html2canvas": "^1.4.1",
    "jspdf": "^2.5.2",
    "jspdf-autotable": "^3.5.28",
    "ngx-clipboard": "^16.0.0",
    "ngx-spinner": "^22.0.1",
    "primeflex": "^3.2.1",
    "primeicons": "^5.0.0",
    "primeng": "^22.1.4",
    "quill": "^1.3.7",
    "rxjs": "~7.8.1",
    "tslib": "^2.3.0",
    "ua-parser-js": "0.7.36",
    "uuid": "^14.0.3",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.3",
    "@types/jasmine": "~4.3.0",
    "@types/node": "^18.19.130",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ts-node": "^10.9.2",
    "typescript": "~6.0.0"
  }
}
